import styled from 'styled-components';

export const GridContainer = styled.div<{ isMultileg?: boolean }>`
  display: grid;
  grid-template-columns: ${({ isMultileg }) => (isMultileg ? '1fr' : '') + ' 1.5fr 1.5fr 1.5fr 1.5fr'};
  gap: ${({ theme }) => theme.spacing8}px;
  max-width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing8}px;
`;

export const HeaderCell = styled.div<{ align?: 'right' }>`
  text-align: ${({ align }) => align || 'left'};
`;

export const DataCell = styled.div<{ align?: 'right' }>`
  text-align: ${({ align }) => align || 'left'};
  color: ${({ theme }) => theme.colorTextImportant};
`;
